/**
 * Rutas de Procesos
 * Gestión de procesos: datos maestros, parámetros, BOM, rutas, instrucciones, control
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import DatosMaestrosProcesos from '../pages/procesos/master-data/DatosMaestrosProcesos.jsx'
import ParametrosProcesos from '../pages/procesos/parameters/ParametrosProcesos.jsx'
import BOMRutas from '../pages/procesos/bom-rutas/BOMRutas.jsx'
import InstruccionesTrabajo from '../pages/procesos/work-instructions/InstruccionesTrabajo.jsx'

import ProcesosAutomaticos from '../pages/procesos/automatic-processes/ProcesosAutomaticos.jsx'
import Events from '../pages/procesos/events/Events.jsx'
import Energy from '../pages/procesos/energy/Energy.jsx'

export const processesRoutes = [
  <Route 
    key="datos-maestros-procesos" 
    path="/datos-maestros-procesos" 
    element={
      <ProtectedRoute>
        <DatosMaestrosProcesos />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="parametros-procesos" 
    path="/parametros-procesos" 
    element={
      <ProtectedRoute>
        <ParametrosProcesos />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="bom-rutas" 
    path="/bom-rutas" 
    element={
      <ProtectedRoute>
        <BOMRutas />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="instrucciones-trabajo" 
    path="/instrucciones-trabajo" 
    element={
      <ProtectedRoute>
        <InstruccionesTrabajo />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="procesos-automaticos" 
    path="/procesos-automaticos" 
    element={
      <ProtectedRoute>
        <ProcesosAutomaticos />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="events" 
    path="/events" 
    element={
      <ProtectedRoute>
        <Events />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="energy" 
    path="/energy" 
    element={
      <ProtectedRoute>
        <Energy />
      </ProtectedRoute>
    } 
  />,
]

